import {
    buttons,
    actions as navigationActions,
    selectors as navigationSelectors
} from './navigation'
import { actions as newShareActions } from './newShare'

export const remixExistingShare = () => (dispatch, getState) => {
    const { viewShare } = getState()

    if (!viewShare || !viewShare.katexCode)
        return Promise.reject('No math to remix!')

    dispatch(newShareActions.createNewShare(viewShare.katexCode))
    return Promise.resolve()
}

export const handleCodeChange = katexCode => (dispatch, getState) => {
    const { navigation } = getState()

    const isSaveButtonDisabled = navigationSelectors.isButtonDisabled(
        navigation
    )(buttons.save)

    dispatch(newShareActions.onCodeChange(katexCode))

    if (!katexCode) {
        dispatch(navigationActions.disableButton(buttons.save))
        return
    }

    if (isSaveButtonDisabled) {
        dispatch(navigationActions.enableButton(buttons.save))
    }
}



// WEBPACK FOOTER //
// ./src/ducks/common.js